import getAxios from 'getAxios';

export default () => {
  const axios = getAxios();

  return axios;
};
